export default {
  home: {
    contentArea: '内容区',
    title: '蔚青大学',
    index: '首页',
    positions: '学术招聘',
  },
}
